export default __webpack_public_path__ + "static/media/who-we-are.32cd341f.png";